import React, { createContext, useContext, useMemo } from 'react';
import { getDefaultTheme, getThemeConfig } from '../Utils/themeConfig';

const ThemeContext = createContext(null);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Theme is ONLY controlled via .env file (REACT_APP_DEFAULT_THEME)
  // No localStorage, no UI switching
  const currentTheme = getDefaultTheme();
  
  const themeConfig = useMemo(() => getThemeConfig(currentTheme), [currentTheme]);

  // changeTheme function kept for backward compatibility but does nothing
  const changeTheme = () => {
    console.warn('Theme switching is disabled. Theme is controlled via .env file (REACT_APP_DEFAULT_THEME)');
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, themeConfig, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
